import { render } from "./teacher.vue?vue&type=template&id=03b66392&scoped=true&ts=true"
import script from "./teacher.vue?vue&type=script&lang=ts"
export * from "./teacher.vue?vue&type=script&lang=ts"

import "./teacher.vue?vue&type=style&index=0&id=03b66392&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b66392"]])

export default __exports__